import { Component, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-direct-offer-made-dialog',
  templateUrl: './direct-offer-made-dialog.component.html',
  styleUrls: ['./direct-offer-made-dialog.component.scss'],
  standalone: true,
  imports: [NgIf, TranslatePipe],
})
export class DirectOfferMadeDialogComponent {
  activeModal = inject(NgbActiveModal);
}
